'use strict';

const compareWidget = require('../compare-widget'),
    productTile = require('../product-tile'),
    progress = require('../progress'),
    appendParamToURL = require('../modules/util/appendParamToURL'),
    getQueryStringParams = require('../modules/util/getQueryStringParams'),
    getQueryParameter = require('../modules/util/getQueryParameter'),
    removeParamFromURL = require('../modules/util/removeParamFromURL'),
    filter = require('./search-filter'),
    isInViewport = require('../modules/helpers/isInViewport'),
    isSmallView = require('../modules/helpers/isSmallView'),
    debounce = require('../modules/helpers/debounce'),
    customSelect = require('../select-custom'),
    grid = require('../grid'),
    gtm = require('../modules/google').tagManager;

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url) {
    if (!url || url === window.location.href) {
        return;
    }
    progress.show($('.search-result-content'));

    $.ajax({
        url: appendParamToURL(url, 'format', 'ajax'),
        success: function (data) {
            if (data) {

                filter.handleGwpAsset(function(){
                    $('.js-grid-wrap .js-grid-item').remove();
                    $('.js-grid-wrap').append(data);
                });

                compareWidget.init();

                progress.hide();
                history.pushState(undefined, '', url);
                filter.init();

                $('.js-grid-wrap').imagesLoaded(function () {
                    grid.init();
                });

                customSelect.init();
            }
        }
    });
}

function accessibilityAdjustment() {
    const $triggerFilter = $('.js-trigger-mobile-filters');
    $triggerFilter.each(function () {
        if ($(this).parent('.mobile-filter-trigger').length) {
            if (!isSmallView()) {
                $(this).attr('tabindex', '-1').attr('aria-hidden', 'true');
            } else {
                $(this).removeAttr('tabindex').removeAttr('aria-hidden');
            }
        }
    });
}

function searchGWPAssetPosition() {
    if ($('.js-search-grid-asset').length) {
        const searchAsset = '.js-search-grid-asset';
        const desktopAssetHolder = '.js-search-slot-desktop';
        const mobileFirstGridItem = $('.js-search-result-content').find('.js-grid-item').first();
        if (isSmallView()) {
            $(desktopAssetHolder).find(searchAsset).appendTo(mobileFirstGridItem);
        } else {
            $(mobileFirstGridItem).find(searchAsset).appendTo(desktopAssetHolder);
        }
    }
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    const $main = $('#main');

    // compare checked
    $main.on('click', 'input[type="checkbox"].compare-check', function () {
        const cb = $(this);
        const tile = cb.closest('.product-tile');

        const func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
        const itemImg = tile.find('.product-image a img').first();
        func({
            itemid: tile.data('itemid'),
            uuid: tile[0].id,
            img: itemImg,
            cb: cb
        });

    });

    // handle events for updating grid
    $main.on('click', '.js-refinement-link, .pagination a, .breadcrumb-refinement-value a', function (e) {
        // don't intercept for category and folder refinements, as well as unselectable
        if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
            return;
        }
        e.preventDefault();
        updateProductListing(this.href);
    });

    // handle events item click. append params.
    $main.on('click', '.product-tile a:not("#quickviewbutton")', function () {
        const a = $(this);
        // get current page refinement values
        const wl = window.location;

        const qsParams = (wl.search.length > 1) ? getQueryStringParams(wl.search.substr(1)) : {};
        const hashParams = (wl.hash.length > 1) ? getQueryStringParams(wl.hash.substr(1)) : {};

        // merge hash params with querystring params
        const params = $.extend(hashParams, qsParams);
        if (!params.start) {
            params.start = 0;
        }
        // get the index of the selected item and save as start parameter
        const tile = a.closest('.product-tile');
        const idx = tile.data('idx') ? + tile.data('idx') : 0;

        // convert params.start to integer and add index
        params.start = (+params.start) + (idx + 1);
        // set the hash and allow normal action to continue
        a[0].hash = $.param(params);
    });

    $(window).on('resize', debounce(function () {
        accessibilityAdjustment();
        searchGWPAssetPosition();
    }, 200));

    $(window).scroll(function () {
        stickyNavBar();
    });
}

/**
 * Pushes a "sorting changed" event to the GTM data layer.
 * Depending on the page we're in, sends along the page category
 * or the search phrase.
 */
function pushSortingToDataLayer(sortingType){
    const category = $('#pageCategory').val();
    const searchPhrase = $('#pageSearchPhrase').val();

    if (category) {
        gtm.pushSortingOnCategoryPage(sortingType);
    } else if (searchPhrase) {
        gtm.pushSortingOnSearchPage(sortingType, searchPhrase);
    }
}

function initGridOptionsEvents(){
    const $main = $('#main');
    const start = 'start';
    const size = 'sz';

    // handle sorting change
    $main.on('change', '.sort-by select', function (e) {
        e.preventDefault();
        const selectedOption = $(this).find('option:selected');

        pushSortingToDataLayer(selectedOption.text());
        updateProductListing(selectedOption.val());

        const $loadMore = $('.js-grid-load-more');
        if ($loadMore) {
            const sizeValue = getQueryParameter(selectedOption.val(), size);
            let nextPageUrl = removeParamFromURL(selectedOption.val(), start);

            nextPageUrl = appendParamToURL(nextPageUrl, start, sizeValue);

            $loadMore.data('grid-next-page-url', nextPageUrl);
        }
    })
    .on('change', '.items-per-page select', function () {
        const refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            updateProductListing(refineUrl);
        }
    });
}

function stickyNavBar() {
    const $filterBar = $('.js-search-results-bar');

    if (!$filterBar.length) {
        return;
    }

    const barIsInView = isInViewport($filterBar);
    const filterBarPosition = $filterBar.offset().top;

    if (isSmallView()) {
        if ($(window).scrollTop() >= filterBarPosition) {
            $filterBar.addClass('sticky-filters');
            return;
        }

        $filterBar.removeClass('sticky-filters');
        return;
    }

    if (barIsInView) {
        $filterBar.removeClass('sticky-filters');
    } else {
        if ($(window).scrollTop() >= filterBarPosition) {
            $filterBar.addClass('sticky-filters');
        }
    }

    const $darkBox = $('.js-search-filter-box');
    if ($darkBox.length && isInViewport($darkBox)) {
        $filterBar.removeClass('sticky-filters-visible');
        return;
    }

    $filterBar.addClass('sticky-filters-visible');
}

exports.init = function () {
    productTile.init();
    initializeEvents();
    initGridOptionsEvents();
    filter.init();
    compareWidget.init();
    accessibilityAdjustment();
    searchGWPAssetPosition();
    stickyNavBar();
};

exports.initGridOptionsEvents = initGridOptionsEvents;
